import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'loading': false,
};

export const vehicleSystems = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ACTIVE_VEHICLE_SYSTEMS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACTIVE_VEHICLE_SYSTEMS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ACTIVE_VEHICLE_SYSTEMS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
